import React from 'react'
import { Image, Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer';
import Logo from "./img/logo.png";

const Facture = () => {
    const styles = StyleSheet.create({
        page: {
          padding: 30,
        },
        section: {
          margin: 10,
          padding: 10,
          flexGrow: 1,
        },
        header: {
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 20,
        },
        logo: {
          width: 100,
          height: 100,
        },
        textRight: {
          textAlign: 'right',
        },
      });
      
    const InvoiceTitle = () => (
        <>
            <Image src={Logo} />
        </>
    )
  return (
    <div>
        <div className="min-h-screen bg-gradient-to-t from-pink-100 via-pink-50 to-pink-100 flex flex-col justify-center pt-24 pb-5 sm:px-6 lg:px-8 px-6">
        <h1>lklk</h1>
        <InvoiceTitle />
        </div>
    </div>
  )
}

export default Facture